import { TicketStatus } from "generated/graphql";
import { SupportTicket, TabKey } from "./types";

export const filterByTab = (
  tickets: SupportTicket[],
  tab: TabKey,
): SupportTicket[] => {
  switch (tab) {
    case "open":
      return tickets.filter((t) => t.status !== TicketStatus.Resolved);
    case "resolved":
      return tickets.filter((t) => t.status === TicketStatus.Resolved);
    default:
      return tickets;
  }
};

/** "Jane Doe · Vendor (Acme EV)" or "Jane Doe · Portal client of Acme EV". */
export const requesterLabel = (ticket: SupportTicket): string => {
  const role = ticket.portalVendorName
    ? `Portal client of ${ticket.portalVendorName}`
    : ticket.requesterRole === "vendor"
      ? `Vendor${ticket.requesterBusinessName ? ` (${ticket.requesterBusinessName})` : ""}`
      : "User";

  return `${ticket.requesterName} · ${role}`;
};
